import { computed, ref } from 'vue'
import type { Ref } from 'vue'
import type { JourneyProduct, JourneyProductErrors } from '@/types/idf-journey-product'

type JourneyProductListErrors = Record<number, JourneyProductErrors>

function validateProduct(product: JourneyProduct): JourneyProductErrors {
  const result: JourneyProductErrors = {}

  if (!product.rdCode) result.rdCode = 'RD code is verplicht'

  if (Number.isNaN(product.gewicht)) {
    result.gewicht = 'Gewicht is ongeldig'
  } else if (
    product !== null &&
    product.gewicht !== null &&
    typeof product.gewicht !== 'string' &&
    product.gewicht! <= 0
  ) {
    result.gewicht = 'Gewicht moet groter dan 0 zijn'
  }

  return result
}

export function useJourneyProductValidation(journeyProducts: Ref<JourneyProduct[]>) {
  const submitted = ref(false)

  const errors = computed<JourneyProductListErrors>(() => {
    if (!submitted.value) return {}

    return journeyProducts.value.reduce<JourneyProductListErrors>((acc, product, index) => {
      const productErrors = validateProduct(product)
      if (Object.keys(productErrors).length > 0) {
        acc[index] = productErrors
      }
      return acc
    }, {})
  })

  const isValid = computed(() =>
    journeyProducts.value.every(product => Object.keys(validateProduct(product)).length === 0)
  )

  function validate(): boolean {
    submitted.value = true
    return isValid.value
  }

  function resetProductErrors() {
    submitted.value = false
  }

  function errorsForProduct(uuid: string): JourneyProductErrors {
    const index = journeyProducts.value.findIndex(product => product.uuid === uuid)
    return index !== -1 ? (errors.value[index] ?? {}) : {}
  }

  return { errors, isValid, validate, errorsForProduct, resetProductErrors }
}
